import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './styles/global.css'
import './index.css'
import { initGA4 } from './utils/ga4'

// Initialize Google Analytics 4
initGA4();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename="/generative-ai-readiness">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)